export default "__VITE_ASSET__bx5$odJp__"